module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kNzfF"))).then(() => parcelRequire('hEqeo'));